import React, { useState } from 'react';

import { SEARCH_RESULTS_LIMIT } from '~/common/constants/max_lengths';
import { FormattedMessage } from 'react-intl';
import Alert from '~/ui/components/Alert/Alert';
import Box from '~/ui/components/Box/Box';

const SearchLimitWarning = ({ resultCount }) => {
  const [showAlert, setShowAlert] = useState(true);

  return showAlert && resultCount > SEARCH_RESULTS_LIMIT ? (
    <Box mb={4}>
      <Alert onDismiss={() => setShowAlert(false)} enableIcon variant="warning">
        <FormattedMessage
          id="SearchLimitWarning.searchLimitMessage"
          defaultMessage="Your search query generated more than {limit} results. <strong>Only {limit} search results will be shown</strong>, please refine your search query or export the full set of search result for viewing."
          description="Warning message when search results exceed the limit. Example: limit = 10000"
          values={{
            limit: SEARCH_RESULTS_LIMIT,
            strong: (chunks) => <strong>{chunks}</strong>,
          }}
        />
      </Alert>
    </Box>
  ) : null;
};

export default SearchLimitWarning;
